"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugUnknownException = exports.ButtplugPingException = exports.ButtplugMessageException = exports.ButtplugDeviceException = exports.ButtplugInitException = exports.ButtplugException = void 0;
const Messages = __importStar(require("./Messages"));
class ButtplugException extends Error {
    constructor(aMessage, aErrorClass, aId = Messages.SYSTEM_MESSAGE_ID, aInner) {
        super(aMessage);
        this.errorClass = Messages.ErrorClass.ERROR_UNKNOWN;
        this.errorClass = aErrorClass;
        this.innerError = aInner;
        this.messageId = aId;
    }
    get ErrorClass() {
        return this.errorClass;
    }
    get InnerException() {
        return this.innerError;
    }
    get Id() {
        return this.messageId;
    }
    get ErrorMessage() {
        return new Messages.Error(this.message, this.ErrorClass, this.Id);
    }
    static LogAndError(aConstructor, aLogger, aMessage, aId = Messages.SYSTEM_MESSAGE_ID) {
        aLogger.Error(aMessage);
        return new aConstructor(aMessage, aId);
    }
    static FromError(aError) {
        switch (aError.ErrorCode) {
            case Messages.ErrorClass.ERROR_DEVICE:
                return new ButtplugDeviceException(aError.ErrorMessage, aError.Id);
            case Messages.ErrorClass.ERROR_INIT:
                return new ButtplugInitException(aError.ErrorMessage, aError.Id);
            case Messages.ErrorClass.ERROR_UNKNOWN:
                return new ButtplugUnknownException(aError.ErrorMessage, aError.Id);
            case Messages.ErrorClass.ERROR_PING:
                return new ButtplugPingException(aError.ErrorMessage, aError.Id);
            case Messages.ErrorClass.ERROR_MSG:
                return new ButtplugMessageException(aError.ErrorMessage, aError.Id);
            default:
                throw new Error(`Message type ${aError.ErrorCode} not handled`);
        }
    }
}
exports.ButtplugException = ButtplugException;
class ButtplugInitException extends ButtplugException {
    constructor(aMessage, aId = Messages.SYSTEM_MESSAGE_ID) {
        super(aMessage, Messages.ErrorClass.ERROR_INIT, aId);
    }
}
exports.ButtplugInitException = ButtplugInitException;
class ButtplugDeviceException extends ButtplugException {
    constructor(aMessage, aId = Messages.SYSTEM_MESSAGE_ID) {
        super(aMessage, Messages.ErrorClass.ERROR_DEVICE, aId);
    }
}
exports.ButtplugDeviceException = ButtplugDeviceException;
class ButtplugMessageException extends ButtplugException {
    constructor(aMessage, aId = Messages.SYSTEM_MESSAGE_ID) {
        super(aMessage, Messages.ErrorClass.ERROR_MSG, aId);
    }
}
exports.ButtplugMessageException = ButtplugMessageException;
class ButtplugPingException extends ButtplugException {
    constructor(aMessage, aId = Messages.SYSTEM_MESSAGE_ID) {
        super(aMessage, Messages.ErrorClass.ERROR_PING, aId);
    }
}
exports.ButtplugPingException = ButtplugPingException;
class ButtplugUnknownException extends ButtplugException {
    constructor(aMessage, aId = Messages.SYSTEM_MESSAGE_ID) {
        super(aMessage, Messages.ErrorClass.ERROR_UNKNOWN, aId);
    }
}
exports.ButtplugUnknownException = ButtplugUnknownException;
//# sourceMappingURL=Exceptions.js.map